import { jsx } from "react/jsx-runtime";
import { c } from "react/compiler-runtime";
import { dehydrate, HydrationBoundary } from "@tanstack/react-query";
import { Suspense } from "react";
import { getQueryClient } from "./queryClient.js";
const NextHydrationBoundary = (t0) => {
  const $ = c(6);
  const {
    children
  } = t0;
  let T0;
  let T1;
  let t1;
  let t2;
  if ($[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel")) {
    const queryClient = getQueryClient();
    T1 = Suspense;
    t2 = /* @__PURE__ */ jsx("div", { children: "Loading..." });
    T0 = HydrationBoundary;
    t1 = dehydrate(queryClient);
    $[0] = T0;
    $[1] = T1;
    $[2] = t1;
    $[3] = t2;
  } else {
    T0 = $[0];
    T1 = $[1];
    t1 = $[2];
    t2 = $[3];
  }
  let t3;
  if ($[4] !== children) {
    t3 = /* @__PURE__ */ jsx(T1, { fallback: t2, children: /* @__PURE__ */ jsx(T0, { state: t1, children }) });
    $[4] = children;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};
export {
  NextHydrationBoundary as default
};
